export class AbcryptResponseModel {
  public status: string;
  public data: string;
  public error: string;
}
